import React, { createContext, useContext, useState, useCallback } from 'react';

const SearchStateContext = createContext(null);

export function SearchStateProvider({ children }) {
  const [searchState, setSearchState] = useState({
    workingAddress: '',
    stayingAddress: '',
  });

  const updateSearchState = useCallback((updates) => {
    setSearchState((prev) => ({ ...prev, ...updates }));
  }, []);

  return (
    <SearchStateContext.Provider value={{ searchState, updateSearchState }}>
      {children}
    </SearchStateContext.Provider>
  );
}

export function useSearchState() {
  const ctx = useContext(SearchStateContext);
  return ctx || { searchState: { workingAddress: '', stayingAddress: '' }, updateSearchState: () => {} };
}
